




























import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import LoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import ManagedAccountQuestions from "@/shared/components/investments/drivewealth/ManagedAccountQuestions.vue";
import ManagedAccountConfirmPortfolio from "@/shared/components/investments/drivewealth/ManagedAccountConfirmPortfolio.vue";

@Component({
  components: {
    LoadingSpinner,
    ManagedAccountQuestions,
    ManagedAccountConfirmPortfolio,
  }
})
export default class Questionnaire extends Vue {
  isSubmitting = false;
  isQuizMode = true;

  @Prop({required: true})
  isWizard: boolean;

  @Prop({required: false})
  username: string;

  @Prop({required: false})
  partnerId: number;

  @Prop({required: false})
  currentPortfolioId: string;

  @Prop() accountId: number;

  onSubmitting (value: boolean) {
    this.isSubmitting = value;
  }

  questionsAnswered () {
    this.isQuizMode = false;
  }

  onReAnswer () {
    this.isQuizMode = true;
  }

  onPortfolioSelected () {
    this.$emit("shouldAdvance");
  }
}
